export const CONTACTS = {
  email: "yazziestech@gmail.com",
  whatsappDisplay: "+91 63839 26053",
  whatsappLink: "https://wa.me/916383926053",
  linkedin: "https://www.linkedin.com/in/eliyas-yazzies-domains-4589a3372/",
  facebook: "https://www.facebook.com/profile.php?id=61581411731149",
};

export const BRAND = {
  name: "PremiumNameShop",
  tagline: "A Curated Portfolio of Premium Domain Names",
};
